<template>
  <BaseModal
    :modal-name="name"
    max-width="max-w-2xl"
    :hide-overflow="false"
    @closed="onCloseModal"
  >
    <div class="w-full text-center">
      <p class="mb-4 text-2xl font-medium text-darkestGray">
        {{ $t('cart.choose_city') }}
      </p>
    </div>

    <div class="text-center text-darkestGray">
      {{ $t('cart.select_city_to_add_item_to_order') }}
    </div>

    <div class="mt-10 flex w-full justify-center">
      <CartSelectCityList v-model="selectedCity" />
    </div>

    <div class="mt-10 flex items-center justify-center space-x-8 text-sm">
      <BaseButton theme="link" size="lg" @click="onClickCancel">
        {{ $t('action.cancel') }}
      </BaseButton>

      <BaseButton
        theme="domPrimary"
        size="normal"
        class="w-40"
        @click="onClickConfirm"
      >
        {{ $t('action.confirm') }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { useModalsStore } from '~~/stores/modals'
import { useCartStore } from '~/stores/cart'

const name = 'chooseCityModal'
const modalsStore = useModalsStore()
const cartStore = useCartStore()

const isConfirmed = ref(false)
const selectedCity = ref(null)

const onClickCancel = () => {
  cartStore.clearItems()
  modalsStore.close(name)
}

const onClickConfirm = async () => {
  if (selectedCity.value) {
    isConfirmed.value = true
    cartStore.setSelectedCity(selectedCity.value)
    await cartStore.updateServicesPrices()
    await cartStore.fetchNursingServices()
  }

  modalsStore.close(name)
}

const onCloseModal = () => {
  if (!isConfirmed.value) {
    selectedCity.value = null
    cartStore.clearItems()
  } else {
    isConfirmed.value = false
  }

  cartStore.isAddingToCart = false
}
</script>
